/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeGoCampaign_PoliticalDistrictGroups.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Political District Group Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Saturday, July 06, 2019 - 06:10:28 PM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      07/06/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const POLITICALDISTRICTGROUP_LIST_CONTAINER_LOADED = 'POLITICALDISTRICTGROUP_LIST_CONTAINER_LOADED';
export const POLITICALDISTRICTGROUP_LIST_CONTAINER_UNLOADED = 'POLITICALDISTRICTGROUP_LIST_CONTAINER_UNLOADED';
export const POLITICALDISTRICTGROUP_LIST_TABLE_LOADED = 'POLITICALDISTRICTGROUP_LIST_TABLE_LOADED';
export const POLITICALDISTRICTGROUP_LIST_TABLE_UNLOADED = 'POLITICALDISTRICTGROUP_LIST_TABLE_UNLOADED';

export const POLITICALDISTRICTGROUP_LIST_CHANGE_GROUP = 'POLITICALDISTRICTGROUP_LIST_CHANGE_GROUP';
export const POLITICALDISTRICTGROUP_SELECT_ROW = 'POLITICALDISTRICTGROUP_SELECT_ROW';

export const POLITICALDISTRICTGROUP_ADD = 'POLITICALDISTRICTGROUP_ADD';
export const POLITICALDISTRICTGROUP_EDIT = 'POLITICALDISTRICTGROUP_EDIT';
export const POLITICALDISTRICTGROUP_DELETE = 'POLITICALDISTRICTGROUP_DELETE';
export const POLITICALDISTRICTGROUP_OPEN_WARNING = 'POLITICALDISTRICTGROUP_OPEN_WARNING';
export const POLITICALDISTRICTGROUP_CLOSE_WARNING = 'POLITICALDISTRICTGROUP_CLOSE_WARNING';
export const POLITICALDISTRICTGROUP_DELETE_DISABLE = 'POLITICALDISTRICTGROUP_DELETE_DISABLE';
export const POLITICALDISTRICTGROUP_VIEW_CHILD_ITEMS = 'POLITICALDISTRICTGROUP_VIEW_CHILD_ITEMS';

export const POLITICALDISTRICTGROUP_EDIT_CONTAINER_LOADED = 'POLITICALDISTRICTGROUP_EDIT_CONTAINER_LOADED';
export const POLITICALDISTRICTGROUP_EDIT_CONTAINER_UNLOADED = 'POLITICALDISTRICTGROUP_EDIT_CONTAINER_UNLOADED';
export const POLITICALDISTRICTGROUP_EDIT_FORM_LOADED = 'POLITICALDISTRICTGROUP_EDIT_FORM_LOADED';
export const POLITICALDISTRICTGROUP_EDIT_FORM_UNLOADED = 'POLITICALDISTRICTGROUP_EDIT_FORM_UNLOADED';

export const POLITICALDISTRICTGROUP_SET_GROUP_SELECT = 'POLITICALDISTRICTGROUP_SET_GROUP_SELECT';
export const POLITICALDISTRICTGROUP_EDIT_DATA_LOAD = 'POLITICALDISTRICTGROUP_EDIT_DATA_LOAD';

export const POLITICALDISTRICTGROUP_EDIT_CONTAINER_SUBMIT = 'POLITICALDISTRICTGROUP_EDIT_CONTAINER_SUBMIT';
export const POLITICALDISTRICTGROUP_EDIT_CONTAINER_CANCEL = 'POLITICALDISTRICTGROUP_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeGoCampaign_PoliticalDistrictGroups.js